import IEntriesRepository from '../../domain/IEntriesRepository';
import entriesRepository from '../../infrastructure/repositories/EntriesRepository';

class DownloadEntriesInPlantUseCase {
  private readonly _entriesRepository: IEntriesRepository;

  constructor({ entriesRepository }) {
    this._entriesRepository = entriesRepository;
  }

  execute({ queryParams }: { queryParams: object }) {
    return this._entriesRepository.downloadEntriesInPlant({
      queryParams
    });
  }
}

export default new DownloadEntriesInPlantUseCase({
  entriesRepository: entriesRepository
});

export { DownloadEntriesInPlantUseCase };
